import { inject, ShallowRef } from 'vue'
import { Map } from 'mapbox-gl'
import { MapBoxProvideInstanceEnum } from '../enums/MapBoxProvideInstance.enum'

export function useMapBox() {
	const map = inject<ShallowRef<Map | undefined>>(MapBoxProvideInstanceEnum.MAP)
	const draw = inject<ShallowRef<MapboxDraw | undefined>>(MapBoxProvideInstanceEnum.DRAW)

	return { map, draw }
}
